import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ImpressionPixel',
  props: {
    impressionTag: null
  },
  emits: ["pixelFired"],
  setup(__props: any) {





return { __sfc: true, }
}

})